// Dialog state
const dialogState = {
  open: true,
  close: false,
};

// Endpoint for delay diallers
const delayDiallersEndPoint = 'admin/delay_dialler';

const BLINKIT_ORG_ID = 1;
const BISTRO_ORG_ID = 4;
const HYPERPURE_ORG_ID = 3;

// Table headings
const tableHeadings = [
  { name: 'Karma Score', key: 1, width: 'tw-w-[24%]' },
  { name: 'ETA Buffer (in mins)', key: 2, width: 'tw-w-[14%]' },
  { name: 'Expiry Time', key: 3, width: 'tw-w-[15%]' },
  { name: 'Updated By', key: 4, width: 'tw-w-[18%]' },
  { name: 'Updated At', key: 5, width: 'tw-w-[15%]' },
  { name: 'Default ETA Buffer (in mins)', key: 6 },
];

const SELECT_ALL = 'select-all';

const rowStyles =
  'tw-px-2 tw-py-4 tw-border-r tw-border-solid tw-border-y-0 tw-border-l-0 tw-border-grey-200 tw-leading-normal';

// ETA limits
const ETA_LIMITS = {
  MIN: 5,
  MAX: 30,
};

const multiSelectStyles = `
                    .searchWrapper .search-wrapper {
                      max-height: 100rem !important;
                      height: 100px !important;
                      z-index: -1 !important;
                    }
                    .option:hover {
                      background-color: #318616 !important;
                    }
                    .chip {
                      border-radius: 0.6rem !important;
                    }
                  `;

const TEXT = {
  SELECT_ATLEAST_ONE_SECTION:
    'Please select at least one karma before adding a new section',
  ALL_OPTIONS_SELECTED: 'All Karma scores have been selected.',
  SELECT_ATLEAST_ONE_KARMA:
    'Please assign delay dialers to at least one karma before updating.',
  EXPIRY_TIME_BTW_5_AND_30: 'ETA Buffer should be between 5 and 30 minutes.',
  DD_REMOVED_SUCCESSFULLY: 'Delay dialler removed successfully',
};

export {
  dialogState,
  tableHeadings,
  delayDiallersEndPoint,
  TEXT,
  ETA_LIMITS,
  multiSelectStyles,
  SELECT_ALL,
  rowStyles,
  HYPERPURE_ORG_ID,
  BLINKIT_ORG_ID,
  BISTRO_ORG_ID,
};
